/** Shared look of text inputs and selects. */
export const fieldStyles = [
  "w-full rounded-[var(--radius-md)] border border-ds-gold-primary/30 bg-ds-black-primary/60",
  "font-body text-[length:var(--font-size-base)] text-ds-text-primary placeholder:text-ds-text-muted/70",
  "transition-[border-color,box-shadow] duration-150 ease-in-out",
  "hover:border-ds-gold-primary/60",
  "focus-visible:border-ds-gold-accent focus-visible:outline-none focus-visible:shadow-ds-gold",
  "disabled:cursor-not-allowed disabled:opacity-50",
  "aria-[invalid=true]:border-ds-error aria-[invalid=true]:focus-visible:shadow-[0_0_20px_rgba(239,68,68,0.4)]",
].join(" ");

export const fieldSizes = {
  sm: "h-9 px-3 text-[length:var(--font-size-sm)]",
  md: "h-11 px-4",
  lg: "h-14 px-5 text-[length:var(--font-size-lg)]",
} as const;

export type FieldSize = keyof typeof fieldSizes;
